import { createContext, useContext } from 'react';

export const TemplateVariablesContext = createContext<string[]>([]);

export const useTemplateVariables = (): string[] => useContext(TemplateVariablesContext);
